import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { QUANTITY_MAX, REASON_MAX } from '../../../../../Consts/licences.const';
import {
  ResumeLicencesDialogData,
  ResumeLicencesDialogResult,
} from '../../../Interfaces/licence-dialog.interface';

@Component({
  selector: 'app-resume-licences-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, TranslateModule],
  templateUrl: './resume-licences-dialog.component.html',
  styleUrl: './resume-licences-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResumeLicencesDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<ResumeLicencesDialogComponent, ResumeLicencesDialogResult>>(MatDialogRef);

  readonly data = inject<ResumeLicencesDialogData>(MAT_DIALOG_DATA);

  readonly quantityMax = QUANTITY_MAX;
  readonly reasonMax = REASON_MAX;

  readonly pendingComponents = this.data.components.filter(
    (component) => component.pending_cancellation > 0,
  );

  readonly formGroup: FormGroup = this._formBuilder.group({
    component_type: [this.pendingComponents[0]?.component_type ?? '', [Validators.required]],
    quantity: [1, [Validators.required, Validators.min(1), Validators.max(QUANTITY_MAX)]],
    reason: ['', [Validators.required, Validators.maxLength(REASON_MAX)]],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({
      componentType: String(this.formGroup.value.component_type),
      quantity: Number(this.formGroup.value.quantity),
      reason: String(this.formGroup.value.reason).trim(),
    });
  }

  cancel(): void {
    this._dialogRef.close();
  }
}
